<template>
  <div class="container" style="margin-top:100px">
    <div class="col">
      <div class="row">
      <div class="col-lg-6 m-hide">
        <picture><img :src="$S3_url+'/Assets/images/register.png'" class="mbi banner_img" /></picture>
      </div>
      <div class="col-lg-6">
        <div class="col-lg-9 m-auto">
          <div class="row">
            <div class="col" style="padding-bottom:25px;">
              <h1 class="text-center" style="color: #007bff">
                <b> Employer register</b>
              </h1>
            </div>
          </div>
          <form ref="register-form" id="client_type" @submit="postClientReg">
            <div id="fieldset-1" label-for="Account-Type">
              <v-autocomplete v-model="register.acctype" :items="acctype.options" label="Account Type" item-value="value" item-text="text" :class="{'is-invalid':typeof validate.response.acctype != 'undefined' &&!validate.response.acctype.val}" placeholder="Account Type" @input="validate.checkIfEmpty(register.acctype, 'acctype', 'Select Account Type')" clearable outlined ></v-autocomplete>
              <div class="error-feedback" v-if="(typeof validate.response.acctype!= 'undefined' &&!validate.response.acctype.val)">{{ validate.response.acctype.msg }}</div>
            </div>
            <div label-for="company-name" id="client-cname" class="mt-5">
              <v-text-field type="text" v-model="register.cname" label="Company name"  outlined></v-text-field>
              <div class="error-feedback" v-if="(typeof validate.response.company_name != 'undefined' && !validate.response.company_name.val)">
                {{ validate.response.company_name.msg }}
              </div>
            </div>
            <div id="client-name" label-for="name" class="mt-5">
              <v-text-field  type="text" v-model="register.cpname" label="Contact person name"  outlined></v-text-field>
              <div class="error-feedback" v-if="(typeof validate.response.name != 'undefined' && !validate.response.name.val)">
                {{ validate.response.name.msg }}
              </div>
            </div>
            <div label-for="mobile" id="client-mobile" class="mt-5">
              <v-text-field type="tel" @keydown.space.prevent v-model="register.mob" label="Mobile number" @input="validate.mobileValidation(register.mob, 'tel')"  outlined></v-text-field>
              <div class="error-feedback" v-if="(typeof validate.response.tel != 'undefined' && !validate.response.tel.val) || (can_register > 0 && !validate.response.tel.val)" >
                {{ validate.response.tel.msg }}
              </div>
              <div class="error-feedback" v-if="mobile_error">{{mob_msg}}</div>
            </div>
            <div label-for="email" id="client_email" class="mt-5">
              <!-- <input id="label-email" v-model="register.email" placeholder="Email" :class="{'is-invalid':typeof validate.response.email != 'undefined' &&!validate.response.email.val}" class="form-control" @input="validate.emailValidation(register.email, 'email')">
              <label for="label-email">Email</label> -->
              <v-text-field type="text" id="popover-button-sync" v-model="register.email" label="Official Email Id" @input="validate.emailValidation(register.email, 'email')" @keydown.space.prevent  outlined></v-text-field>

              <b-popover :show.sync="show" placement="top" target="popover-button-sync" title="">
                <div class="email_popover_close" @click="show=false">x</div>
                Recommend entering your official email id, as it helps to verify your job postings faster. (Eg:-Yourname@Company.com)
              </b-popover>

              <div class="error-feedback" v-if="(typeof validate.response.email != 'undefined' && !validate.response.email.val)">
                {{ validate.response.email.msg }}
              </div>
              <div class="error-feedback" v-if="email_error">{{email_msg}}</div>
            </div>
            <div label-for="password" id="client_password" class="mt-5">
              <v-text-field :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" v-model="register.password" label="Password" @input="validate.passwordValidation(register.password, 'password')"  outlined></v-text-field>
              <div class="error-feedback" v-if="(typeof validate.response.password != 'undefined' && !validate.response.password.val)">
                {{ validate.response.password.msg }}
              </div>
            </div>
            <b-form-group id="client_city" label-for="City" class="mt-5">
              <v-autocomplete v-model="register.city" label="Select City" :items="states" item-text="text" item-value="id" :searchable="true" @input="validate.checkIfEmpty(register.city, 'city', 'Select City')" clearable outlined deletable-chips> 
                <template slot="item" slot-scope="data">
                  <template v-if = typeof(data.item) != 'object'>
                    <v-list-item-content v-text="data.item.text"/>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.text"/>
                      <v-list-item-sub-title v-html="data.item.group"/>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>          
              <div class="error-feedback" v-if="(typeof validate.response.city != 'undefined' && !validate.response.city.val)">{{ validate.response.city.msg }}</div>
            </b-form-group>
            <div class="text-center">
              <b-button type="submit" class="mr-3 text-center" variant="primary" v-if="!isSigning">Register</b-button>
              <b-button class="mr-3 mt-3 btn-signup"  style="cursor: no-drop;color:#fff !important;font-size:10px;" variant="primary" v-if="isSigning" disabled>Registering...</b-button>
              <div class="error-feedback" v-if="sign_error">Error in some fields, please scroll up, correct & resubmit</div>
            </div>
          </form>
          <div class="text-center mt-3">
            <p class="text-secondary mb-0">
              <small class="mb-0"><i>By creating an account, you agree to Hireclap<a href="/recruit/terms" target="noopener"> Terms & conditions</a> &<a href="/recruit/privacy" target="noopener"> Privacy policy. </a></i></small>
            </p>
            <p>Are you a Jobseeker? <a href="/jobseeker/register">Register Free</a></p>
          </div>
        </div>
      </div>
    </div>
    </div>
    
  </div>
</template>


<script>
export default {
  name: "RecruiterReg",
  beforeMount(){
  //Calls right after page load
  this.getStates();
  },
  data() {
    return {
      validate: new this.$valid(),
      acctype: {
        options: [
          { value: 1, text: "Employer" },
          { value: 2, text: "Consultant" },
          // { value: 3, text: "Individual" },
          { value: 4, text: "Institute" },
        ],
      },
      cities: [],
      states:[],
      metro_cities:[],
      register: {
        cname: null,
        email: null,
        password: null,
        mob: null,
        acctype: 1,
        cpname: null,
        city: null,
        src:null
      },
      show1: false,
      errors: [],
      pass_error:false,
      email_error : false,
      mobile_error : false,
      error_msg:'',
      pass_msg:'',
      email_msg:'',
      validation: true,
      moreinfo: false,
      can_register: 0,
      isSigning:false,
      show: false,
      sign_error:false,
    };
  },
  methods:{
    checkFormValidity() {
      const valid = (this.register.cname && this.register.email && this.register.password  && this.register.acctype  && this.register.cpname &&this.register.city && this.register.mob)? true : false;
      return valid;
    },
    getStates: async function () {
      await new this.$apiAction().getStates().then(async (data) => {
        this.states.push({header: 'Top Metropolitan Cities'})
        await data.states.forEach(async (element) => {
          await element.cities.forEach(city => {
            if(city.top_city == 1){
              this.states.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
            }
          });
          this.states.push({divider:true})
          this.states.push({header: element.state_name});
          element.cities.forEach(city => {
            if(city.top_city == 0){
              this.states.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:element.state_name})
            }
        });
      });
      });
    },
    postClientReg: function (e) {
      e.preventDefault();
      this.can_register = 0;
      this.isSigning = true;
      var scrolledY;
      this.sign_error = false;
      if (this.validate.emailValidation(this.register.email, "email")?.val === false) {
        this.can_register++;
      }
      if (this.validate.passwordValidation(this.register.password, "password")?.val === false) {
        this.can_register++;
      }
      if (this.validate.mobileValidation(this.register.mob, "tel")?.val === false) {
        this.can_register++;
      }
      if(this.validate.checkIfEmpty(this.register.cname, "company_name", 'Enter Company name')?.val === false){
        this.can_register++;
      }
      if(this.validate.textValidation(this.register.cpname, "name", 'Enter Contact person name')?.val === false){
        this.can_register++;
      }
      if(this.validate.checkIfEmpty(this.register.acctype, "acctype", 'Select Account Type')?.val === false){
        this.can_register++;
      }
      if(this.validate.checkIfEmpty(this.register.city, "city", 'Select City')?.val === false){
        this.can_register++;
      }
            
      if (this.can_register === 0) {
        this.register.src = (this.$route.query.src)? this.$route.query.src: 'home-register';
        new this.$apiAction().employerRegister(this.register).then(res => {
          this.isSigning= false;
        if(res.message == 'Employer Registration Success'){
          this.$router.push({name:'rec_login', params: {success_msg: 'Successfully registered. You can login now.'}})
          // this.$router.push('/recruit/login');
        }else {
          this.sign_error = true;
          if(res.mob !== undefined){
            this.mobile_error = true;
            this.mob_msg = res.mob[0];
            document.getElementById('client_mobile').scrollIntoView(true);
            scrolledY = window.scrollY;
            if(scrolledY){
              window.scroll(0, scrolledY - 100);
            }
          }
          if(res.email !== undefined){
            this.email_error = true;
            this.email_msg = res.email[0];
            document.getElementById('client_email').scrollIntoView(true);
            scrolledY = window.scrollY;
            if(scrolledY){
              window.scroll(0, scrolledY - 100);
            }
          }
        }
      }).catch(err => {
        console.log(err);
        this.isSigning= false;
        this.sign_error = true;
      })
    }else{
      this.isSigning = false;
      this.sign_error = true;
      if(this.validate.checkIfEmpty(this.register.acctype, "acctype", 'Select Account Type')?.val === false){
        document.getElementById('client-type').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }else if(this.validate.checkIfEmpty(this.register.cname, "company_name", 'Enter Company name')?.val === false){
        document.getElementById('client-cname').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }else if(this.validate.checkIfEmpty(this.register.cpname, "name", 'Enter Contact person name')?.val === false){
        document.getElementById('client-name').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }else if(this.validate.mobileValidation(this.register.mob, "tel")?.val === false) {
        document.getElementById('client-mobile').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }else if(this.validate.emailValidation(this.register.email, "email")?.val === false) {
        document.getElementById('client_email').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }else if(this.validate.passwordValidation(this.register.password, "password")?.val === false) {
        document.getElementById('client_password').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }else if(this.validate.checkIfEmpty(this.register.city, "city", 'Select City')?.val === false){
        document.getElementById('client_city').scrollIntoView(true);
        scrolledY = window.scrollY;
        if(scrolledY){
          window.scroll(0, scrolledY - 100);
        }
      }
      
    }
  }
  }
};
</script>


<style>
.banner_img{
  display: block;
  max-width: 610px;
}
.v-text-field__details{
  display: none !important;
}
.v-input__slot{
  margin-bottom: 0px !important;
} 
</style>
